<script>
import { CdrLandingLead } from '@rei/cedar';
import EditorsChoiceBadge from '../../../utils/SVGs/EditorsChoiceBadge.vue';

export default {
  name: 'EditorsChoiceAwardIntroImage',
  components: {
    EditorsChoiceBadge,
    CdrLandingLead,
  },
  props: {
    heroImage: {
      type: String,
      default: '',
    },
    heroImageAltText: {
      type: String,
      default: '',
    },
    contentIntro: {
      type: String,
      default: '',
    },
    contentIntroMobile: {
      type: String,
      default: '',
    },
    headerId: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    baseClassName: 'ea-editors-choice-award-intro-image',
  }),
  computed: {
  },
  methods: {
  },
};
</script>

<template>
  <section :class="`${baseClassName}`">
    <div :class="`${baseClassName}__image_container`">
      <CdrLandingLead
        :class="`${baseClassName}__image`"
        :img-src="heroImage"
        :img-alt="heroImageAltText"
      />

      <editors-choice-badge
        :class="`${baseClassName}__image_overlay`"
        color="white"
      />
      <div :class="`${baseClassName}__text_overlay`">
        <p
          v-if="contentIntro"
          :class="`${baseClassName}__text_for_desktop`"
          data-ui="contentIntro"
          v-html="contentIntro"
        />
        <p
          v-if="contentIntroMobile"
          :class="`${baseClassName}__text_for_mobile`"
          data-ui="contentIntroMobile"
          v-html="contentIntroMobile"
        />
      </div>
    </div>
    <div
      :id="headerId"
      :class="`${baseClassName}__header_container`"
    >
      <h1 :class="`${baseClassName}__header`">
        {{ headerContent }}
      </h1>
      <p
        :class="`${baseClassName}__text_for_mobile`"
        v-html="contentIntroMobile"
      />
    </div>
  </section>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

$baseClassName: 'ea-editors-choice-award-intro-image';

.#{$baseClassName} {
  @include cdr-sm-mq-up {
    background-color: $cdr-color-background-primary;
  }
}
.#{$baseClassName}__image_container {
  position: relative;
  background-color: $cdr-color-background-primary;
}
.#{$baseClassName}__image img {
  width: 100%;
  object-position: top;
  object-fit: cover;

  @include cdr-xs-mq-only {
    height: 100vw;
  }
  @include cdr-sm-mq-up {
    height: 40vw;
  }

}
.#{$baseClassName}__image_overlay {
  position: absolute;
  z-index: 1;
  top: 3vw;
  left: 3vw;
  width: 12vw;
  height: 12vw;
  @include cdr-xs-mq-only {
    top: 15vw;
    left: 6vw;
    width: 40vw;
    height: 40vw;
  }
}
.#{$baseClassName}__text_overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: $cdr-space-two-x 16vw 2vw 16vw;
  background: linear-gradient(1turn,rgba(0,0,0,.8),rgba(0,0,0,.5) 65%,transparent);
  color: $cdr-color-text-inverse;
  white-space: pre-wrap;
  word-wrap: break-word;

  @include cdr-sm-mq-down {
    display: none;
  }
  .#{$baseClassName}__text_for_desktop {
    display: block;
  }
  .#{$baseClassName}__text_for_mobile {
    display: none;
  }

  @include cdr-md-mq-down {
    .#{$baseClassName}__text_for_desktop {
      display: none;
    }
    .#{$baseClassName}__text_for_mobile {
      display: block;
    }
  }
}

$paddingHeaderText: calc(16vw - #{$cdr-space-two-x});
.#{$baseClassName}__header_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $cdr-space-three-x $cdr-space-one-x $cdr-space-half-x $cdr-space-one-x;

  @include cdr-xs-mq-only {
    position: relative;
    margin: -36vw $paddingHeaderText $cdr-space-two-x $paddingHeaderText;
    padding: $cdr-space-two-x;
    border-radius: $cdr-radius-softer;
    text-align: center;
    background-color: $cdr-color-background-primary;

    .#{$baseClassName}__header {
      margin-bottom: $cdr-space-one-and-a-half-x;
    }
  }
}
.#{$baseClassName}__header {
  margin: $cdr-space-three-x 0;

  @include cdr-xs-mq-only {
    @include cdr-text-utility-sans-strong-300;
    text-transform: uppercase;
  }
  @include cdr-sm-mq-only {
    @include cdr-text-heading-display-1000;
  }
  @include cdr-md-mq-only {
    @include cdr-text-heading-display-1200;
  }
  @include cdr-lg-mq-up {
    @include cdr-text-heading-display-1400;
  }
}

.#{$baseClassName}__text_overlay {
  .#{$baseClassName}__text_for_desktop {
    margin: $cdr-space-two-x auto;
    @include cdr-text-utility-sans-600;
    @include cdr-md-mq-only {
      @include cdr-text-utility-sans-400;
    }
    @include cdr-lg-mq-only {
      @include cdr-text-utility-sans-600;
      line-height: 3.6rem;
    }
  }
  .#{$baseClassName}__text_for_mobile {
    @include cdr-text-utility-sans-400;
  }
}
.#{$baseClassName}__text_for_mobile {
  @include cdr-xs-mq-only {
    @include cdr-text-body-400;
  }
  @include cdr-sm-mq-up {
    display: none;
  }
}

</style>
